module.exports = __webpack_public_path__ + "static/media/icon_usdt_bw.64dc9738.svg";